import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { SharedConstants } from "../../constants/shared.constants";
export let WebNotificationService = class WebNotificationService {
    _permissionGranted;
    constructor() {
        this.requestPermission();
    }
    showNotification(title, text) {
        if (this._permissionGranted) {
            this.createNewNotification(title, text);
        }
        else {
            throw new Error(SharedConstants.PERMISSION_NOT_GRANTED_FOR_NOTIFICATIONS_ERROR);
        }
    }
    requestPermission() {
        if (!("Notification" in window)) {
            throw new Error(SharedConstants.NO_NOTIFICATION_BROWSER_SUPPORT_ERROR);
        }
        this.getPermissionRequest().then((permissionResponse) => {
            this.handlePermissionResponse(permissionResponse);
        });
    }
    getPermissionRequest() {
        return Notification.requestPermission();
    }
    handlePermissionResponse(permissionResponse) {
        if (Notification.permission === "granted" && permissionResponse === "granted") {
            this._permissionGranted = true;
        }
    }
    removePermission() {
        this._permissionGranted = false;
    }
    createNewNotification(title, text) {
        return new Notification(title, { body: text });
    }
    static ctorParameters = () => [];
};
WebNotificationService = __decorate([
    Injectable({
        providedIn: "root"
    })
], WebNotificationService);
